<script>
import {ref} from "vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import router from "@/router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
// import {Device} from "@capacitor/device";
// import {CallNumber} from "capacitor-call-number";
import {useStore} from "vuex";
import useClipboard from "vue-clipboard3";

export default {
  name: "LoginPage",
  components: {LoadingPage},
  setup(){

    let store = useStore()
    let privacy = ref(false)
    let phone = ref('')
    let loading = ref(false)

    function login() {
      if (phone.value.length === 0){Swals.Warning('لطفا شماره همراه خود را وارد کنید!') ; return false}
      if (phone.value.length !== 11 || phone.value.charAt(0) !== '0' || phone.value.charAt(1) !== '9'){Swals.Warning('لطفا شماره همراه خود را به صورت صحیح وارد کنید!') ; return false}
      if (!privacy.value){Swals.Warning('پذیرفتن شرایط و قوانین و حریم خصوصی الزامی می باشد!') ; return false}

      loading.value = true
      FreeWorld.Heisenberg({phone:phone.value} , 'login_phone').then((res)=>{
        loading.value = false
        if (res.data.status === 'ok'){
        router.push({name:'OtpPage' , params:{phone:phone.value}})
        }else {
          Swals.Fault('متاسفانه مشکلی پیش آمده است!')
        }
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , login)
      })
    }

    let show_support = ref(true)
    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    // function call_support() {
    //
    //   let phone_support = FreeWorld.PinkMan(store.state.info.support , 'de')
    //   Device.getInfo().then(info => {
    //     if (info.platform === "web"){
    //       window.location.href = 'tel:' + phone_support
    //     }else{
    //       CallNumber.call({ number: phone_support , bypassAppChooser: true });
    //     }
    //   });
    //
    // }

    return{
      privacy,
      phone,
      login,
      loading,
      show_support,
      call_support,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div class="" :class="loading ? 'activeClass':''" id="main">

    <div class="holder-logo rounded-bottom-5 w-100 max_width">
      <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-start">
        <img class="img_logo" src="../assets/img/logoapp.png" alt="">

        <div class="list-access bg-white rounded-4 p-2 shadow-custom">
          <div class="position-relative">
            <div class="rounded-pill text-white shadow-custom font-5 bg-color-liner p-3">
              <p class="text-center font-bold">ورود به اپلیکیشن</p>
            </div>

            <p class="font-5 text-center mt-4">لطفا شماره همراه خود را وارد کنید</p>

            <input v-model="phone" @keyup.enter="login" @focusout="show_support = true" @focusin="show_support = false" class="shadow-custom rounded-pill p-3 text-center my-4 w-100" type="tel" maxlength="11" placeholder="شماره همراه">

            <div class="mb-6 d-flex align-items-center">
              <input v-model="privacy" id="privacy" type="checkbox">
              <label class="font-6 mr-2" for="privacy">
                تمام
                <router-link :to="{name:'PrivacyPage' , params:{action:'apprules'}}" href="">شرایط و قوانین</router-link>
                برنامه و
                <router-link :to="{name:'PrivacyPage' , params:{action:'privacy'}}">حریم خصوصی</router-link>
                را میپذیرم
              </label>
            </div>

            <div class="btn-center w-100 d-flex justify-content-center position-absolute">
              <div @click="login" class="p-1 bg-white w-50 shadow-custom rounded-pill">
                <p class="bg-color-liner p-3 text-center text-white font-bold rounded-pill">ارسال کد</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="show_support" class="position-fixed w-100 max_width d-flex bottom-1">
      <a href="https://sangin-savaran.com/" target="_blank" class="bg-color-light text-decoration-none p-1 d-flex align-items-center rounded-pill me-2 shadow">
        <img style="width: 3rem" class="icon_shadow" src="../assets/img/icon-call-bg-white.svg" alt="">
        <p class="font-5 text-color mx-3">کمک بگیرید</p>
      </a>
    </div>
  </div>

</template>

<style scoped>
.img_logo {
  width: 35%;
  margin-top: 55px;
}
.holder-logo {
  background-image: linear-gradient(to bottom left, #46E2FF, #268EE0, #0335BE);
  position: fixed;
  top: 0;
  height: 45%;
}
.list-access {
  position: absolute;
  bottom: -15rem;
  width: 80%;
}
.btn-center{
  bottom: -6.6rem;
}
</style>